import React, { Component } from "react";

const GlobalStateContext = React.createContext({});

export class GlobalStateProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bryntumState: {
        schedulerInstance: null,
      },
      createBlockModalState: {
        block: null,
        eventRecord: null,
        isOpen: false,
      },
      deleteConfirmationModalState: {
        data: {},
        isOpen: false,
      },
      editDowntimeModalState: {
        block: null,
        isOpen: false,
      },
      editNotesPopUpState: {
        isOpen: false,
        workBlockId: null,
        workOrderId: null,
      },
      editWorkBlockModalState: {
        block: null,
        isOpen: false,
      },
      notificationState: {
        isPresent: false,
        message: "",
        title: "",
        type: "",
      },
      publishScheduleModalState: {
        isOpen: false,
      },
      publishSummaryModalState: {
        data: {},
        isOpen: false,
      },
      publishWorkBlockModalState: {
        isOpen: false,
        workBlock: {},
      },
      showDowntimeModalState: {
        block: null,
        isOpen: false,
      },
      showWorkBlockModalState: {
        block: null,
        isOpen: false,
      },
      updateAvailabilityOverridesUnsavedChangesModalState: {
        endDate: null,
        isOpen: false,
        startDate: null,
      },
      updateConfirmDefaultAvailabilityChangesModalState: {
        isOpen: false,
      },
      updateWorkOrderDatesModalState: {
        isOpen: false,
      },
    };

    this.currentState = this.state;
  }

  // Fetches current application state synchronously.
  // This is useful if you need to access current application state before setState async updates
  getCurrentState = () => this.currentState;

  updateState = (newState) => {
    const oldState = this.currentState;

    this.currentState = {
      ...oldState,
      ...newState,
    };

    this.setState(this.currentState);
  };

  contextValue = () => ({ getState: this.getCurrentState, setState: this.updateState, state: this.state });

  render() {
    return <GlobalStateContext.Provider value={this.contextValue()}>{this.props.children}</GlobalStateContext.Provider>;
  }
}

export default GlobalStateContext;
